
import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";

const UsersGroup = () => {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const q = query(
          collection(db, "whatsupgroup"),
          where("active", "==", true)
        );

        const snapshot = await getDocs(q);

        const groupList = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setGroups(groupList);
      } catch (err) {
        console.error("Error fetching WhatsApp links:", err);
        setError(
          "Imeshindikana kupakia WhatsApp Groups na Channels. Tafadhali jaribu tena."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchGroups();
  }, []);

  // Groups za zamani zisizo na type zitaonekana kama Community.
  const communityGroups = groups.filter(
    (item) => !item.type || item.type === "community"
  );

  const channels = groups.filter(
    (item) => item.type === "channel"
  );

  const openWhatsApp = (link, type) => {
    if (typeof link !== "string") {
      setError("Link ya WhatsApp haipo au si sahihi.");
      return;
    }

    try {
      const url = new URL(link);
      let valid = false;

      if (type === "channel") {
        valid =
          url.protocol === "https:" &&
          ["whatsapp.com", "www.whatsapp.com"].includes(
            url.hostname
          ) &&
          /^\/channel\/[A-Za-z0-9_-]+\/?$/.test(url.pathname);
      } else {
        valid =
          url.protocol === "https:" &&
          url.hostname === "chat.whatsapp.com" &&
          /^\/[A-Za-z0-9]+\/?$/.test(url.pathname);
      }

      if (!valid) {
        setError("Link ya WhatsApp si sahihi.");
        return;
      }

      setError("");
      window.open(link, "_blank", "noopener,noreferrer");
    } catch {
      setError("Link ya WhatsApp si sahihi.");
    }
  };

  const renderSection = ({
    title,
    items,
    type,
    icon,
    buttonText,
    emptyText,
  }) => (
    <section style={styles.section}>
      <h3 style={styles.sectionHeading}>
        {icon} {title}
      </h3>

      {items.length === 0 ? (
        <p style={styles.empty}>{emptyText}</p>
      ) : (
        <div style={styles.list}>
          {items.map((item) => (
            <div key={item.id} style={styles.card}>
              <div style={styles.icon}>{icon}</div>

              <div style={styles.details}>
                <h4 style={styles.groupName}>
                  {item.groupName ||
                    (type === "channel"
                      ? "WhatsApp Channel"
                      : "WhatsApp Community")}
                </h4>

                <p style={styles.status}>
                  {type === "channel"
                    ? "WhatsApp Channel"
                    : "WhatsApp Community Group"}
                </p>
              </div>

              <button
                type="button"
                style={styles.button}
                onClick={() =>
                  openWhatsApp(item.whatsappLink, type)
                }
              >
                {buttonText}
              </button>
            </div>
          ))}
        </div>
      )}
    </section>
  );

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h2 style={styles.heading}>
          💚 WhatsApp Community & Channels
        </h2>

        <p style={styles.description}>
          Karibu! Jiunge na WhatsApp Community Groups zetu au
          fuatilia WhatsApp Channels ili kupata taarifa na matangazo.
        </p>

        {loading && (
          <p style={styles.info}>
            ⏳ Inapakia WhatsApp Groups na Channels...
          </p>
        )}

        {!loading && error && (
          <p style={styles.error}>{error}</p>
        )}

        {!loading && !error && groups.length === 0 && (
          <p style={styles.info}>
            Hakuna WhatsApp Groups au Channels zilizopo kwa sasa.
            Tafadhali jaribu tena baadaye.
          </p>
        )}

        {!loading && groups.length > 0 && (
          <>
            {renderSection({
              title: "WhatsApp Community Groups",
              items: communityGroups,
              type: "community",
              icon: "👥",
              buttonText: "Join Group",
              emptyText:
                "Hakuna Community Groups zilizoongezwa kwa sasa.",
            })}

            {renderSection({
              title: "WhatsApp Channels",
              items: channels,
              type: "channel",
              icon: "📢",
              buttonText: "Follow Channel",
              emptyText:
                "Hakuna WhatsApp Channels zilizoongezwa kwa sasa.",
            })}
          </>
        )}
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: "100vh",
    boxSizing: "border-box",
    padding: "20px 14px 120px",
    background: "#101522",
    color: "#fff",
  },
  container: {
    width: "100%",
    maxWidth: "700px",
    margin: "0 auto",
  },
  heading: {
    textAlign: "center",
    color: "#25d366",
    marginBottom: "12px",
  },
  description: {
    textAlign: "center",
    lineHeight: 1.7,
    color: "#d1d5db",
    marginBottom: "28px",
  },
  section: {
    marginBottom: "30px",
  },
  sectionHeading: {
    color: "#25d366",
    borderBottom: "1px solid #344158",
    paddingBottom: "12px",
    marginBottom: "15px",
    fontSize: "18px",
  },
  list: {
    display: "flex",
    flexDirection: "column",
    gap: "14px",
  },
  card: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "16px 12px",
    borderRadius: "12px",
    background: "#202a3c",
    border: "1px solid #344158",
    flexWrap: "wrap",
  },
  icon: {
    fontSize: "28px",
  },
  details: {
    flex: "1 1 120px",
    minWidth: 0,
  },
  groupName: {
    margin: "0 0 6px",
    fontSize: "16px",
    overflowWrap: "anywhere",
  },
  status: {
    margin: 0,
    color: "#aab5c5",
    fontSize: "12px",
  },
  button: {
    border: "none",
    borderRadius: "8px",
    padding: "11px 15px",
    background: "#25d366",
    color: "#073b20",
    fontWeight: "bold",
    cursor: "pointer",
  },
  info: {
    textAlign: "center",
    color: "#d1d5db",
    padding: "20px 0",
  },
  empty: {
    textAlign: "center",
    color: "#aab5c5",
    background: "#202a3c",
    borderRadius: "8px",
    padding: "15px",
  },
  error: {
    textAlign: "center",
    color: "#ff8b8b",
    padding: "12px",
  },
};

export default UsersGroup;
